import React from "react";
import Mapcomponent from "./Mapcomponent";


const Footer = () => {
    return (
        <div className=" footer">
            <div className="footeritem">
                <div className="logo">
                
                    <h2>SHRI S R CONVENT SCHOOL</h2>
                    

                    <div className="iconparent">
                    
                        <img className="icon" src=" https://cdn2.iconfinder.com/data/icons/buno-ui-interface/32/__map_pin_location-64.png" alt="image not found " />
                    
                    <div className="para">
                        <p>Contact Number</p>
                        <p> +918909861356</p>
                        <p> +919536606018</p>
                    </div>
                    </div>


                    <div className="gmail">
                        <img className="icon" src=" https://cdn-icons-png.flaticon.com/128/4926/4926635.png" alt="image not found " />
                    
                    <p> sr6018@gmail.com</p>
                    </div>
                    
                        <div className="mobile">
                       
                            <img className="icon" src=" https://cdn3.iconfinder.com/data/icons/aami-web-internet/64/aami8-18-64.png" alt="image not fount " />
                    
                    </div>
                </div>
                {/* <div className="quecklink ">
                    <div className="heading">
                        
                    <h2 >Quick Links</h2>
                    </div> 
                    <ul style={{padding: "0px",}}>
                        <li><a href=" /" >Home </a></li>
                        <li><a href=" /" >Aboutus</a> </li>
                        <li><a href=" /" > Services </a></li>
                        <li><a href=" /" > Contact</a></li>
                        
                    </ul>
                </div>  */}
                 <div className="recentpost">
                 <Mapcomponent/> 
                </div>
             

            </div>
            <hr />
            <h3>SHRI S R CONVENT SCHOOL  </h3>
            <p> Theepuri Shamshabad Road Fatehabad Agra </p>
        </div>

    )
}
export default Footer;